import React, { useMemo, useState } from 'react'
import Cookies from 'js-cookie'
import axios from 'axios'
import { toast } from 'react-toastify'
import Topbar from '../layouts/Topbar'
import Sidebar from '../layouts/Sidebar'
import API_BASE_URL from '../../../config/api'
import '../../HR Manager/screens/HRImportKPIs.css'

const EmployeeImportKPIs = () => {
  const baseUrl = API_BASE_URL

  const [file, setFile] = useState(null)
  const [year, setYear] = useState(new Date().getFullYear())
  const [uploading, setUploading] = useState(false)

  const years = useMemo(() => {
    const currentYear = new Date().getFullYear()
    return [currentYear, currentYear + 1]
  }, [])

  const downloadTemplate = () => {
    // Avoid router/base-path issues by fetching then downloading as a blob.
    const publicBase = (process.env.PUBLIC_URL || '').replace(/\/$/, '')
    const href = `${publicBase}/templates/kpi_bulk_template.csv`

    fetch(href, { cache: 'no-store' })
      .then(async (res) => {
        if (!res.ok) {
          throw new Error(`Template not found (${res.status})`)
        }
        const blob = await res.blob()
        const url = URL.createObjectURL(blob)

        const a = document.createElement('a')
        a.href = url
        a.download = `kpi_bulk_template_${year}.csv`
        document.body.appendChild(a)
        a.click()
        a.remove()
        URL.revokeObjectURL(url)
      })
      .catch((err) => {
        console.log(err)
        toast.error('Template file could not be downloaded. Please contact support.')
      })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!file) {
      toast.error('Please select an Excel/CSV file to upload.')
      return
    }

    setUploading(true)
    try {
      const token = Cookies.get('token')
      const formData = new FormData()
      formData.append('file', file)
      formData.append('year', String(year))

      await axios.post(`${baseUrl}/api/goals/bulk-create/`, formData, {
        headers: {
          Authorization: `Bearer ${token}`
          // Let axios set the multipart boundary automatically.
        }
      })

      toast.success('File uploaded successfully.')
      setFile(null)
    } catch (err) {
      console.log(err)
      const message =
        err.response?.data?.detail ||
        err.response?.data?.message ||
        err.response?.data?.error ||
        'Failed to upload file.'
      toast.error(message)
    } finally {
      setUploading(false)
    }
  }

  return (
    <>
      <Topbar />
      <Sidebar />
      <div className="hr-import-kpis-container">
        <div className="hr-import-kpis-inner">
          <div className="hr-import-kpis-header">
            <div>
              <h2 className="hr-import-kpis-title">Import KPIs</h2>
              <p className="hr-import-kpis-subtitle">
                Upload an Excel/CSV file to bulk-create KPIs via <code>/api/goals/bulk-create/</code>.
              </p>
            </div>
          </div>

          <div className="hr-import-kpis-card">
            <form onSubmit={handleSubmit} className="hr-import-kpis-form">
              <div className="hr-import-kpis-row">
                <div className="hr-import-kpis-field hr-import-kpis-file">
                  <label className="hr-import-kpis-label">Excel / CSV file</label>
                  <input
                    type="file"
                    accept=".xlsx,.xls,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv"
                    disabled={uploading}
                    onChange={(e) => setFile(e.target.files?.[0] ?? null)}
                    className="hr-import-kpis-file-input"
                  />
                  
                </div>
              </div>

              <div className="hr-import-kpis-actions">
                <button
                  type="submit"
                  disabled={uploading}
                  className="hr-import-kpis-submit-btn"
                >
                  {uploading ? 'Uploading...' : 'Upload & Submit'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default EmployeeImportKPIs